/**
 * @generated SignedSource<<9b6b8478c623ec871605fa877aea2c84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OrganizationChannelMentionPermission = "admins" | "all" | "%future added value";
export type OrganizationCheckoutVersion = "stripe" | "stripe_acacia" | "%future added value";
export type OrganizationCurrency = "aed" | "afn" | "all" | "amd" | "ang" | "aoa" | "ars" | "aud" | "awg" | "azn" | "bam" | "bbd" | "bdt" | "bgn" | "bmd" | "bnd" | "bob" | "brl" | "bsd" | "bwp" | "byn" | "bzd" | "cad" | "chf" | "cny" | "cop" | "crc" | "cve" | "czk" | "dkk" | "dop" | "dzd" | "egp" | "etb" | "eur" | "fjd" | "fkp" | "gbp" | "gel" | "gip" | "gmd" | "hkd" | "hnl" | "htg" | "huf" | "idr" | "ils" | "inr" | "isk" | "jmd" | "kgs" | "lak" | "lbp" | "lkr" | "lrd" | "lsl" | "mad" | "mdl" | "mkd" | "mmk" | "mnt" | "mop" | "mur" | "mvr" | "mxn" | "myr" | "mzn" | "nad" | "ngn" | "nio" | "nok" | "npr" | "nzd" | "pab" | "pen" | "pgk" | "php" | "pkr" | "pln" | "qar" | "ron" | "rsd" | "rub" | "sar" | "sbd" | "scr" | "sek" | "sgd" | "shp" | "srd" | "std" | "szl" | "thb" | "tjs" | "top" | "try" | "ttd" | "twd" | "uah" | "usd" | "uyu" | "uzs" | "zar" | "zmw" | "%future added value";
export type OrganizationKind = "community" | "workspace" | "%future added value";
export type OrganizationRole = "admin" | "member" | "owner" | "%future added value";
export type OrganizationSubscriptionStatus = "active" | "paused" | "trial" | "trial_expired" | "%future added value";
export type OrganizationVisibility = "private" | "public" | "%future added value";
export type ProductOrderBy = "dates" | "misconfigured_stripe_objects" | "name" | "nav" | "published" | "%future added value";
export type SlackConnectionStatus = "active" | "auth_error" | "inactive" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ActiveOrganizationContextFragment$data = {
  readonly authProvider: {
    readonly allowsJitProvisioning: boolean;
    readonly connectionId: string;
    readonly status: string;
  } | null;
  readonly billingContactEmail: string | null;
  readonly channelMentionPermission: OrganizationChannelMentionPermission;
  readonly checkoutVersion: OrganizationCheckoutVersion | null;
  readonly cover: string | null;
  readonly creationDatetime: string;
  readonly currency: OrganizationCurrency;
  readonly darkLogo: string | null;
  readonly description: string | null;
  readonly exploreProductTabSortBySetting: ProductOrderBy;
  readonly facebookPixelId: string | null;
  readonly faviconUrl: string | null;
  readonly googleAnalyticsId: string | null;
  readonly googleTagManagerId: string | null;
  readonly hasBackfilledStreamMessages: boolean | null;
  readonly id: string;
  readonly isChannelsEnabled: boolean;
  readonly isChatBotEnabled: boolean;
  readonly isDmEnabled: boolean;
  readonly isEventsEnabled: boolean;
  readonly isExploreProductTabHidden: boolean;
  readonly isProductsEnabled: boolean;
  readonly kind: OrganizationKind;
  readonly logo: string | null;
  readonly mobileAppConfig: {
    readonly id: string;
  } | null;
  readonly name: string;
  readonly primaryDomain: string;
  readonly showGlobalTabTitles: boolean;
  readonly slackConnectionStatus: SlackConnectionStatus | null;
  readonly slug: string;
  readonly stripeAccountId: string | null;
  readonly subscription: {
    readonly status: OrganizationSubscriptionStatus;
  } | null;
  readonly timezone: string;
  readonly viewerMembership: {
    readonly hasGroupLeadRole: boolean;
    readonly hasInstructorOrManagerRole: boolean;
    readonly hasSeenOnboarding: boolean;
    readonly id: string;
    readonly role: OrganizationRole;
    readonly shouldInitiateUserflow: boolean;
    readonly streamChatUserId: string | null;
    readonly streamChatUserToken: string | null;
  } | null;
  readonly visibility: OrganizationVisibility;
  readonly " $fragmentSpreads": FragmentRefs<"CommunityBadgeFragment" | "CustomThemeProviderActiveOrganizationFragment" | "LabelsContextActiveOrganizationFragment" | "useBrainSearchBotFragment" | "useChatBotFragment" | "useCommunityLandingPagesFragment" | "useCopilotBotFragment" | "useHasEntitlementActiveOrganizationFragment" | "usePermissionsFragment" | "useSubscriptionStandingActiveOrganizationFragment">;
  readonly " $fragmentType": "ActiveOrganizationContextFragment";
};
export type ActiveOrganizationContextFragment$key = {
  readonly " $data"?: ActiveOrganizationContextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActiveOrganizationContextFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActiveOrganizationContextFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cover",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faviconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDmEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isChannelsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channelMentionPermission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isProductsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExploreProductTabHidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEventsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showGlobalTabTitles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingContactEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleAnalyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookPixelId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleTagManagerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exploreProductTabSortBySetting",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBackfilledStreamMessages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkoutVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "darkLogo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasSeenOnboarding",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streamChatUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasInstructorOrManagerRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasGroupLeadRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streamChatUserToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shouldInitiateUserflow",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationSubscription",
      "kind": "LinkedField",
      "name": "subscription",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthProvider",
      "kind": "LinkedField",
      "name": "authProvider",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "connectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowsJitProvisioning",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MobileAppConfig",
      "kind": "LinkedField",
      "name": "mobileAppConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isChatBotEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slackConnectionStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryDomain",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useHasEntitlementActiveOrganizationFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomThemeProviderActiveOrganizationFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LabelsContextActiveOrganizationFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSubscriptionStandingActiveOrganizationFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CommunityBadgeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCommunityLandingPagesFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useChatBotFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCopilotBotFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrainSearchBotFragment"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "87282c61233e413552c52147809daebe";

export default node;
